/**
 * en-GB messages added by shared reception task S-SR4 (docs/SHARED-RECEPTION-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts. UK English only.
 */
export const sSr4EnGB = {
    // Marshal phone invitation email (the link is the credential; it is emailed, never shown in the portal)
    'email.shared-reception.phone_invite.subject': 'Set up your phone as a fire marshal phone for {building}',
    'email.shared-reception.phone_invite.body': 'You have been asked to use the CloudSign app as a fire marshal for {building}. Open this link on your phone with the CloudSign app installed. The link works once and expires in {hours} hours.',
    'email.shared-reception.phone_invite.button': 'Set up this phone',
    // Refusals
    'error.sr_phones_off': 'Marshal phones are switched off for this building.',
};
//# sourceMappingURL=s-sr4.js.map